import dayjs from 'dayjs'

// eslint-disable-next-line import/prefer-default-export
export const isCurrentCycle = cycle => {
  const current = dayjs()
  return (
    current.isSameOrAfter(cycle.startsAt, 'day') &&
    current.isSameOrBefore(cycle.endsAt, 'day')
  )
}

export function formatCycleRange(cycle, format = 'MMM D, YYYY') {
  if (!cycle) return ''
  const startsAt = cycle.startsAtLong || cycle.startsAt
  const endsAt = cycle.endsAtLong || cycle.endsAt

  const start = startsAt ? dayjs(startsAt).format(format) : ''
  const end = endsAt ? dayjs(endsAt).format(format) : ''
  if (!start) return end
  if (!end) return start
  return `${start} to ${end}`
}
